// Assembles the Finnish locale from its per-section files. Section files are
// grouped into folders by screen family (mirroring src/components); when a
// new section file is added, require it here under the same top-level key
// the components use (e.g. a top-level key like adminMemberList).
module.exports = {
    common: require('./common.json'),
    roles: require('./roles.json'),
    announcements: require('./announcements.json'),
    server: require('./server.json'),
    api: require('./api.json'),

    login: require('./auth/login.json'),
    register: require('./auth/register.json'),
    forgot: require('./auth/forgot.json'),
    reset: require('./auth/reset.json'),

    header: require('./commons/header.json'),
    footer: require('./commons/footer.json'),
    memberNotFound: require('./commons/memberNotFound.json'),

    memberDetails: require('./member/memberDetails.json'),
    memberUpdate: require('./member/memberUpdate.json'),
    pay: require('./member/pay.json'),
    payReturn: require('./member/payReturn.json'),

    adminPurchases: require('./admin/adminPurchases.json'),
    adminAnnouncementDetails: require('./admin/adminAnnouncementDetails.json'),
    adminMemberDetails: require('./admin/adminMemberDetails.json'),
    adminMemberUpdate: require('./admin/adminMemberUpdate.json'),
    adminAddMember: require('./admin/adminAddMember.json'),
    adminMemberList: require('./admin/adminMemberList.json'),
};
